module.exports = __webpack_public_path__ + "static/media/icon@2x.c9244bfe.png";